import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmailSchedulerPage from "@/pages/admin/EmailSchedulerPage";

export const Route = createFileRoute("/_admin/admin/email-scheduler")({
  head: () => pageHead("Admin · Email Scheduler", "AKIVA admin · email scheduler portal.", "/admin/email-scheduler", true),
  component: EmailSchedulerPage,
});
